/**
 * The v2 home a v1 user should be sent to, plus the module that has to be on
 * v2 for it to stick. Mirrors app/react/src/utils/defaultRoute.js (getHomeUrl),
 * always taking the v2 branch.
 *
 * A bare /app/ is not enough: getHomeUrl hands back the v1 URL whenever the
 * role's home module is still on v1, so it loops the user straight back here.
 *
 * Returns null where getHomeUrl already lands on v2 regardless of
 * module_versions (admins, Boom Host / BAM tenants) or there is no v2 home
 * (tourist) — /app/ is correct for those.
 */
const V2_ONLY_PRODUCT_TYPES = ['boom-bam-only', 'boom-bam', 'boom-host']
const NO_TARGET_ROLES = ['admin', 'system_admin', 'tourist']

const COMMUNICATION_ROLES = [
  'communication-manager',
  'communication-agent',
  'sales-manager',
  'sales-agent',
]

const FIELD_OPS_HOME = {
  moduleKey: 'operations_field_ops',
  v2Url: '/app/dashboard/service-calls',
}

const ROLE_HOMES = {
  investor: { moduleKey: 'owners_listings', v2Url: '/app/listings' },
  'hotel-reception': { moduleKey: 'multi_calendar', v2Url: '/app/calendar' },
  // getHomeUrl always sends agents to v1, so this is agent-reservations.vue's
  // own <version-banner> target rather than a getHomeUrl branch.
  agent: {
    moduleKey: 'marketing_agents',
    v2Url: '/app/dashboard/agent-reservations',
  },
}

export const v2HomeTarget = user => {
  if (!user) return null
  if (V2_ONLY_PRODUCT_TYPES.includes(user.tenant?.product_type)) return null

  const { role } = user
  if (NO_TARGET_ROLES.includes(role)) return null
  if (COMMUNICATION_ROLES.includes(role)) {
    return { moduleKey: 'crm', v2Url: '/app/crm' }
  }
  // Field-ops roles and any unknown role — getHomeUrl's fallback branch
  return ROLE_HOMES[role] || FIELD_OPS_HOME
}
